import { useState, useEffect, useContext, createContext } from 'react';

// Контекст для переводов
const TranslationContext = createContext();

// Провайдер переводов
export const TranslationProvider = ({ children, siteSettings }) => {
    const [currentLanguage, setCurrentLanguage] = useState(siteSettings?.currentLanguage || 'ru');
    const [translations, setTranslations] = useState(siteSettings?.translations || {});

    // Обновляем переводы при изменении настроек
    useEffect(() => {
        if (siteSettings?.currentLanguage) {
            setCurrentLanguage(siteSettings.currentLanguage);
        }
        if (siteSettings?.translations) {
            setTranslations(siteSettings.translations);
        }
    }, [siteSettings]);

    // Функция получения перевода
    const t = (key, fallback = key) => {
        const keys = key.split('.');
        
        // Функция для получения значения по пути ключей
        const getValueByPath = (obj, keyPath) => {
            let current = obj;
            for (const k of keyPath) {
                if (current && current[k] !== undefined) {
                    current = current[k];
                } else {
                    return null; // Ключ не найден
                }
            }
            return current;
        };
        
        // Сначала пробуем найти в текущем языке
        let result = getValueByPath(translations[currentLanguage], keys);
        
        // Если найден и это непустая строка - возвращаем
        if (result && typeof result === 'string' && result.trim() !== '') {
            return result;
        }
        
        // Если не найден или пустой - возвращаем ключ для понимания что нужно перевести
        return fallback;
    };

    const value = {
        currentLanguage,
        setCurrentLanguage,
        translations,
        setTranslations,
        t
    };

    return (
        <TranslationContext.Provider value={value}>
            {children}
        </TranslationContext.Provider>
    );
};

// Хук для использования переводов
export const useTranslation = () => {
    const context = useContext(TranslationContext);
    
    if (!context) {
        throw new Error('useTranslation must be used within a TranslationProvider');
    }
    
    return context;
};

// Простой хук для прямого использования без контекста
export const useSimpleTranslation = (siteSettings) => {
    const currentLanguage = siteSettings?.currentLanguage || 'ru';
    const translations = siteSettings?.translations || {};

    const t = (key, fallback = key) => {
        const keys = key.split('.');
        
        // Функция для получения значения по пути ключей
        const getValueByPath = (obj, keyPath) => {
            let current = obj;
            for (const k of keyPath) {
                if (current && current[k] !== undefined) {
                    current = current[k];
                } else {
                    return null; // Ключ не найден
                }
            }
            return current;
        };
        
        // Сначала пробуем найти в текущем языке
        let result = getValueByPath(translations[currentLanguage], keys);
        
        // Если найден и это непустая строка - возвращаем
        if (result && typeof result === 'string' && result.trim() !== '') {
            // Replace bankAccountDisplayName placeholder
            if (result.includes('{{bankAccountDisplayName}}')) {
                const bankAccountDisplayName = siteSettings?.bankAccountDisplayName || 'IBAN/BIC';
                result = result.replace(/\{\{bankAccountDisplayName\}\}/g, bankAccountDisplayName);
            }
            return result;
        }
        
        // Если не найден или пустой - возвращаем fallback с обработкой плейсхолдера
        let finalFallback = fallback;
        if (finalFallback.includes('{{bankAccountDisplayName}}')) {
            const bankAccountDisplayName = siteSettings?.bankAccountDisplayName || 'IBAN/BIC';
            finalFallback = finalFallback.replace(/\{\{bankAccountDisplayName\}\}/g, bankAccountDisplayName);
        }
        return finalFallback;
    };

    return { t, currentLanguage };
};

export default useTranslation;